import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  linkTo?: string;
}

export default function Logo({ size = 'md', showText: _showText = true, linkTo = '/' }: LogoProps) {
  const sizeStyles = {
    sm: { main: 'text-xl', sub: 'text-sm' },
    md: { main: 'text-3xl', sub: 'text-base' },
    lg: { main: 'text-5xl', sub: 'text-lg' },
  };

  const gapStyles = {
    sm: 'gap-1',
    md: 'gap-2',
    lg: 'gap-3',
  };

  const content = (
    <div className={`flex flex-col items-center text-center ${gapStyles[size]}`}>
      {/* 테마 액센트 기반 — 지옥문 스코프(로그인)에선 레드, 앱 내부에선 민트로 자동 정합 */}
      <h1 className={`font-bold ${sizeStyles[size].main} bg-gradient-to-r from-[var(--accent)] to-[var(--accent-dark)] bg-clip-text text-transparent`}>
        헬게이터
      </h1>
      <p className={`${sizeStyles[size].sub} text-text-light font-medium tracking-widest`}>
        HELLGATER
      </p>
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="inline-block hover:opacity-80 transition-opacity">
        {content}
      </Link>
    );
  }

  return content;
}
